import { render } from "./PortfolioModal6.vue?vue&type=template&id=535c2687"
import script from "./PortfolioModal6.vue?vue&type=script&lang=js"
export * from "./PortfolioModal6.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Programación\\Desktop\\openbootcamp\\Vuejs\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__